import React, { useMemo, useState } from 'react';
import { Box, Button } from '@mui/material';
import { WhatsApp as WhatsAppIcon } from '@mui/icons-material';
import EvolutionPrescriptionsSendDialog from './EvolutionPrescriptionsSendDialog';
import type { EvolutionAttachedPrintable } from './evolutionWorkflowTypes';

interface Props {
  printables: EvolutionAttachedPrintable[];
  patientId?: string | null;
  onNotify?: (message: string, severity: 'success' | 'error') => void;
}

/** Envia ao paciente as receitas já anexadas à evolução, mesmo antes de salvá-la. */
const EvolutionPrescriptionsSendButton: React.FC<Props> = ({ printables, patientId, onNotify }) => {
  const [open, setOpen] = useState(false);
  const prescriptionIds = useMemo(
    () => Array.from(new Set(
      printables
        .filter((p) => p.category === 'prescription' && p.linkedDocumentId)
        .map((p) => String(p.linkedDocumentId)),
    )),
    [printables],
  );

  if (!prescriptionIds.length) return null;

  return (
    // O cabeçalho da seção é clicável; eventos do modal (em portal) sobem pela árvore React.
    <Box
      component="span"
      sx={{ display: 'contents' }}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
    >
      <Button
        size="small"
        variant="contained"
        disableElevation
        startIcon={<WhatsAppIcon />}
        onClick={() => setOpen(true)}
        sx={{
          textTransform: 'none',
          fontWeight: 700,
          flexShrink: 0,
          borderRadius: 2,
          bgcolor: '#16a34a',
          '&:hover': { bgcolor: '#15803d' },
        }}
      >
        {prescriptionIds.length > 1 ? `Enviar receitas (${prescriptionIds.length})` : 'Enviar receita'}
      </Button>
      <EvolutionPrescriptionsSendDialog
        open={open}
        mode="pick"
        prescriptionIds={prescriptionIds}
        patientId={patientId}
        onClose={() => setOpen(false)}
        onNotify={onNotify}
      />
    </Box>
  );
};

export default EvolutionPrescriptionsSendButton;
